import {
    EnvironmentData,
    Pipeline,
    Region,
    WorkLane,
} from '../models/EnvironmentModels';
import * as agcpApi from '../api/AGCPApi';

/**
 * Get list of environments from the API
 * Returns an array of environment names from the API response
 */
export const getEnvironmentList = async (): Promise<string[]> => {
    try {
        const response = await agcpApi.getEnvironmentList();

        if (response.succeeded && response.data) {
            // Extract environment names from the data array
            const environmentNames = response.data
                .map((env) => env.name)
                .filter((name) => name && name.trim() !== '');

            console.log(
                'Successfully loaded environment list from API:',
                environmentNames
            );
            return environmentNames;
        } else {
            console.warn('API call failed or returned no data');
            return [];
        }
    } catch (error) {
        console.error('Error fetching environment list:', error);
        return [];
    }
};

/**
 * Fetch environment configuration data by name
 * @param environmentName The environment name
 */
export const fetchEnvironmentData = async (
    environmentName: string
): Promise<EnvironmentData | null> => {
    try {
        const response = await agcpApi.getEnvironment(
            environmentName.toLowerCase()
        );

        if (response.succeeded && response.data) {
            console.log(
                'Successfully loaded environment data from API for:',
                environmentName
            );
            return response.data;
        } else {
            console.warn(
                'API call failed or returned no data for environment:',
                environmentName
            );
            return null;
        }
    } catch (error) {
        console.error('Error fetching environment data:', error);
        return null;
    }
};

/**
 * Save environment configuration data
 * @param environmentData The environment data to save
 */
export const saveEnvironmentData = async (
    environmentData: EnvironmentData
): Promise<{ success: boolean; message?: string; data?: EnvironmentData }> => {
    try {
        const response = await agcpApi.upsertEnvironment(environmentData);

        if (response.succeeded) {
            return {
                success: true,
                message: 'Environment data saved successfully',
                data: response.data,
            };
        } else {
            return {
                success: false,
                message: response.message || 'Failed to save environment data',
            };
        }
    } catch (error) {
        console.error('Error saving environment data:', error);
        return {
            success: false,
            message:
                (error as Error).message || 'Failed to save environment data',
        };
    }
};
